import { useState } from "react";
import useQueryParams from "../useQuery";

export default function useAssetsFilter(variables, type) {
  const queryParams = useQueryParams();
  const [search, setSearch] = useState(variables.search);
  const [limit, setLimit] = useState(variables.limit || 40);

  // Handle both single type (string) and multiple types (array) for backwards compatibility
  const typeFilter = Array.isArray(type)
    ? { types: type, type: undefined }
    : type
    ? { type, types: undefined }
    : {};

  const filter = {
    ...variables,
    search: search,
    limit,
    page: variables.page || 1,
    ...typeFilter,
  };

  return { filter, search, setSearch, limit, setLimit };
} 